import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

import ImageGallery from '../../../common/ImageGallery';

import {
  fetchAddCollectionImage,
  fetchRemoveCollectionImage,
} from '../../../../actions/collections';
import { showModal } from '../../../../actions/modal';

import { parseError } from '../../../../helpers';

const CollectionImage = (props) => {
  const { currentCollection, saveCollection } = props;
  const dispatch = useDispatch();
  const [images, setImages] = useState(
    currentCollection && currentCollection.defaultImage
      ? [{ url: currentCollection.defaultImage, id: 'defaultImage' }]
      : [],
  );

  const handleUploadImages = async (data) => {
    let error = false;
    let id;
    if (!currentCollection) {
      await saveCollection().then((collection) => {
        id = collection.id;
      });
    } else {
      id = currentCollection.id;
    }

    const upfile = data[0];
    const uploadedImage = await dispatch(fetchAddCollectionImage({ id, upfile })).catch((err) => {
      error = true;
      toast.error('Ошибка загрузки изображения ' + upfile.name);
    });

    if (!error) {
      setImages([uploadedImage]);
      toast.info('Изображение успешно загружено');
    }
  };
  const handleDeleteImage = () => {
    return dispatch(fetchRemoveCollectionImage(currentCollection.id))
      .then(() => {
        toast.info('Изображение успешно удалено');
        setImages([]);
      })
      .catch((err) => {
        toast.error(parseError(err));
      });
  };

  const handleClickImage = (image) => {
    dispatch(showModal('ImageEditor', { image, onDelete: handleDeleteImage }));
  };

  return (
    <div className="card-box">
      <div className="row">
        <div className="col-12">
          <h4 className="header-title">Изображение</h4>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <ImageGallery
            images={images}
            isSingle
            showHover
            dropzoneDescription="Перетащите сюда файл или кликните для его выбора"
            onUpload={handleUploadImages}
            // onReorder={handleReorderImages}
            onItemClick={handleClickImage}
          />
        </div>
      </div>
    </div>
  );
};

export default CollectionImage;
